
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    baseUrl: 'https://api.nodum.pro/api',
    authLogin: '/auth/sign-in',
    authSignUp: '/auth/sign-up',
    users: '/users',
    allowedEmails: '/users/allowed-emails',
    usersById: '/users/',
    socialLogin: '/auth/sign/social',
    communities: '/local-governments',
    auth: {
      googleClientId: '291585315916-hu5p7t2kqm5tlsoloqvfh37inll7u01h.apps.googleusercontent.com',
    },
  },
};
